module.exports = __webpack_public_path__ + "d260ce40c1ec6f5f9051361e48f8971f.pdf";